import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions as liveFeedActions } from './LiveFeedSlice'
import {
  getLiveFeedFetching,
  getLiveFeedResponseData
} from './LiveFeedSelector'
import { getConfig } from 'src/features/config/ConfigSelector'
import Svg from 'src/components/Svg'
import FwLiveFeed from 'src/assets/images/livefeed.svg'
import { useChat } from 'src/features/fw-ai/children/dougallChat/hooks'
import LiveFeedItem from './components/item/LiveFeedItem'
import { Typography, Stack, Skeleton, Box } from '@mui/material'
import AdSlotRenderer from './components/Ads/AdSlotRenderer'
import LiveFeedDivider from './components/divider/LiveFeedDivider'
import { getTags } from '../dougallChat/ChatSelector'

const refUrlPharma = process.env.REACT_APP_URL
const refUrlHT = process.env.REACT_APP_URL_MEDDEV

const LiveFeedComponent = () => {
  const dispatch = useDispatch()
  const tags = useSelector(getTags())
  const fetching = useSelector(getLiveFeedFetching())
  const liveFeedData = useSelector(getLiveFeedResponseData())
  const ads = useSelector(state => [
    state.adsReducer.dougalLiveFeedAd1,
    state.adsReducer.dougalLiveFeedAd2,
    state.adsReducer.dougalLiveFeedAd3,
    state.adsReducer.dougalLiveFeedAd4
  ])

  const internalToken = useSelector(getConfig('internal_token')) || null
  const { isTyping } = useChat()

  useEffect(() => {
    if (!isTyping && tags?.length > 0) {
      dispatch(liveFeedActions.requestLiveFeed(tags))
    }
  }, [dispatch, tags, isTyping])

  const renderLiveFeedItems = () => {
    let adCount = 0
    return liveFeedData.map((feed, index) => {
      const link =
        feed?.origin &&
        (feed.origin.includes('MedDev') || feed.origin.includes('HealthTech'))
          ? `${refUrlHT}/story/${feed.articleId}?at=${internalToken}`
          : `${refUrlPharma}/story/${feed.articleId}`

      const elements = [
        <LiveFeedItem
          key={feed.articleId}
          title={feed.title}
          description={feed.description}
          origin={feed.origin}
          link={link}
          tags={[feed.type]}
          isPlus={feed.isPlus}
          destination={feed.tags}
          articleId={feed.articleId}
        />,
        <LiveFeedDivider key={feed.articleId + index} />
      ]

      // Inject ad after 2nd and every 4th item
      if (index === 1 || (index > 1 && (index - 1) % 4 === 0)) {
        elements.push(
          <AdSlotRenderer
            key={`ad-${adCount}`}
            adInfo={ads[adCount]}
            index={adCount}
          />
        )
        adCount = (adCount + 1) % ads.length
      }

      return (
        <React.Fragment key={`feed-block-${feed.articleId}`}>
          {elements}
        </React.Fragment>
      )
    })
  }

  const renderSkeletons = () =>
    Array.from({ length: 20 }).map((_, i) => (
      <Box
        key={`skeleton-${i}`}
        sx={{
          padding: 2,
          backgroundColor: '#fff',
          marginBottom: 10
        }}
      >
        <Stack spacing={1}>
          <Skeleton variant="circular" width={30} height={30} />
          <Skeleton variant="text" width="80%" height={16} />
          <Skeleton variant="text" width="100%" height={12} />
        </Stack>
      </Box>
    ))
  return (
    <Stack spacing={2}>
      <Typography
        sx={{ textAlign: 'center', paddingTop: '10px' }}
        variant="h5"
        color="text.secondary"
      >
        <Svg src={FwLiveFeed} />
      </Typography>
      {(() => {
        if (fetching) {
          return renderSkeletons()
        } else if (liveFeedData?.length > 0) {
          return renderLiveFeedItems()
        } else {
          return (
            <Typography sx={{ textAlign: 'center' }} variant="body2">
              Submit a prompt to see the Live Feed populated with the latest
              news, analysis, reports, or other information related to your
              prompt, or the most recent FirstWord content
            </Typography>
          )
        }
      })()}
    </Stack>
  )
}

export default LiveFeedComponent
